export const LOAD_CART = "LOAD_CART";
export const ADD_PRODUCT = "ADD_PRODUCT";
export const REMOVE_PRODUCT = "REMOVE_PRODUCT";
export const UPDATE_CART = "UPDATE_CART";
export const UPDATE_TAX_INFO = "UPDATE_TAX_INFO";
